/** Drop bullet lines that only repeat video-perception prose on session detail. */
export function insightBulletsBeyondBody(body: string, bullets: string[]): string[] {
  const norm = (s: string) =>
    String(s || "")
      .toLowerCase()
      .replace(/[^\w\s%]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  const bodyNorm = norm(body);
  if (!bodyNorm) return bullets.map((b) => String(b || "").trim()).filter(Boolean);

  const words = (s: string) =>
    norm(s)
      .split(" ")
      .filter((w) => w.length > 2);

  const out: string[] = [];
  for (const raw of bullets) {
    const b = String(raw || "").trim();
    if (!b) continue;
    const bn = norm(b);
    if (!bn) continue;
    if (bodyNorm.includes(bn)) continue;
    if (bn.length >= 12 && bodyNorm.includes(bn.slice(0, Math.min(24, bn.length)))) continue;
    const bw = words(b);
    if (bw.length >= 2) {
      const hits = bw.filter((w) => bodyNorm.includes(w)).length;
      if (hits / bw.length >= 0.72) continue;
    }
    out.push(b);
  }
  return out;
}

export function parseObservationFact(fact: string): { label: string; value: string } {
  const text = String(fact || "").trim();
  const m = text.match(/^(.+?)\s+(\d+%|\d+)$/);
  if (m) return { label: m[1].trim(), value: m[2] };
  return { label: text, value: "" };
}
